import React from "react";
import { Grid2 } from "@mui/material";
import { FundamentalsCard } from "../FundamentalsCard";
import { DividendsChart } from "../DividendsChart/DividendsChart";
import { DetailInformation } from "../DetailInformation/DetailInformation";

export interface Props {
  isin: string;
  quoteProvider?: string;
  tickerSymbol?: string;
  currency?: string;
  isSecurityStock?: boolean;
  areDividendsPresent?: boolean;
}

export const SecurityFundamentalsByIsin = ({
  isin,
  quoteProvider,
  tickerSymbol,
  currency,
  isSecurityStock = false,
  areDividendsPresent = false,
}: Props) => (
  <Grid2 container spacing={4} width="100%" mt={5}>
    {isSecurityStock && (
      <FundamentalsCard>
        <DetailInformation
          isin={isin}
          quoteProvider={quoteProvider}
          tickerSymbol={tickerSymbol}
          currency={currency}
        />
      </FundamentalsCard>
    )}

    {areDividendsPresent && (
      <FundamentalsCard>
        <DividendsChart isin={isin} currency={currency} />
      </FundamentalsCard>
    )}
  </Grid2>
);
